import { useState, createContext, useEffect, useContext } from 'react';
import { useAppSelector } from '@/redux/store';
import { useSearchParams } from 'react-router-dom';
import { TabKey, DEFAULT_TAB } from './_constants/const';

interface MoreContextType {
  currentTab: TabKey;
  setCurrentTab: (tab: TabKey) => void;
}

const MoreContext = createContext<MoreContextType | undefined>(undefined);

export const MoreProvider = ({ children }: { children: React.ReactNode }) => {
  const user = useAppSelector((state) => state.user);
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = (searchParams.get('ctab') as TabKey) || DEFAULT_TAB;

  const [currentTab, setCurrentTab] = useState<TabKey>(tabFromUrl);

  // 쿼리와 상태 동기화
  useEffect(() => {
    setSearchParams({
      ctab: currentTab,
    });
    // eslint-disable-next-line
  }, [currentTab]);

  // 쿼리 변경 시 상태도 동기화
  useEffect(() => {
    if (tabFromUrl !== currentTab) setCurrentTab(tabFromUrl);

    // eslint-disable-next-line
  }, [tabFromUrl]);

  const value = {
    currentTab,
    setCurrentTab,
  };

  return <MoreContext.Provider value={value}>{children}</MoreContext.Provider>;
};

export const useMore = () => {
  const context = useContext(MoreContext);
  if (!context) {
    throw new Error('useMore must be used within a MoreProvider');
  }
  return context;
};
